/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Seo_Trainer_DescriptionInputs */

const en_seo_trainer_description = /** @type {(inputs: Seo_Trainer_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: open times, sessions and prices. Book online.`)
};

const pl_seo_trainer_description = /** @type {(inputs: Seo_Trainer_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: wolne terminy, zajęcia i ceny. Zarezerwuj online.`)
};

/**
* | output |
* | --- |
* | "{name}: open times, sessions and prices. Book online." |
*
* @param {Seo_Trainer_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_trainer_description = /** @type {((inputs: Seo_Trainer_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Trainer_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_trainer_description(inputs)
	return en_seo_trainer_description(inputs)
});